/* eslint-disable*/
import qs from "qs"
import _ from "lodash"
import "whatwg-fetch"
import {getMgtvUserTicket, h5Logout, judgeLogin} from "utils/user"
import Vue from 'vue';

const METHOD_GET = "GET"
const CONTENT_TYOE_JSON = 'JSON'
const CONTENT_TYOE_FORM = 'FORM'
const STANDBY_API = "shopapi2.da.mgtv.com"
const TIMEOUT_TIME = 10000 // 10s

function objectToFormData(obj, form, namespace) {
    const fd = form || new FormData()
    Object.keys(obj).forEach(key => {
        let formKey
        if (namespace) {
            formKey = `${namespace}[${key}]`
        } else {
            formKey = key
        }
        const value = obj[key]
        if (value != null) {
            if (typeof value === "object" && !(value instanceof File)) {
                objectToFormData(value, fd, formKey)
            } else {
                // if it's a string or a File object
                fd.append(formKey, value)
            }
        } else {
            fd.append(formKey, "")
        }
    })
    return fd
}

function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response
    } else if (response.status === 488 || response.status === 503) {
        const errorMsg = '前方道路拥挤，请稍后再试'
        const error = new Error(errorMsg)
        error.code = 488
        error.message = errorMsg
        throw error
    } else {
        const error = new Error(response.statusText)
        error.response = response
        error.code = 100
        throw error
    }
}

class ApiInvoker {
    constructor() {
        this.handledInvalidToken = false
        this.invalidTokenHandler = function () {
        }
    }

    request = async (api, data = {}, options = {}, isTestApi, isTicket) => {
        if (!navigator.onLine) {
            const error = new Error()
            error.code = 1
            error.message = "无法连接到网络"
            throw error
        }
        const {
            method = METHOD_GET, type = CONTENT_TYOE_FORM
        } = options
        const userInfo = getMgtvUserTicket()
        data.t = new Date().getTime()
        if (!_.isEmpty(userInfo) && userInfo.ticket) {
            if (isTicket) {
                data.ticket = userInfo.ticket
            } else {
                data.token = userInfo.ticket
            }
        }
        const xdebug = 13140;
        if (process.env.VUE_APP_ENV === "local") {
            // xdebug 测试参数
            data.XDEBUG_SESSION_START = xdebug;
        }
        if (sessionStorage.getItem('inviteid')) {
            data.inviteid = JSON.parse(sessionStorage.getItem('inviteid'));
        }
        let response
        let res
        let isGet = true
        let params = ""
        if (method.toUpperCase() === METHOD_GET) {
            params = qs.stringify(data)
            const fetchURL = params ? `${api}?${params}` : api
            res = fetch(fetchURL, {
                credentials: "include"
            }).catch(err => {
                const errorMsg = '前方拥挤，请稍后重试'
                const error = new Error(errorMsg)
                error.code = 503
                error.message = errorMsg
                throw error
            })
        } else {
            isGet = false
            let fetchdata = {
                method,
                credentials: "include",
                body: objectToFormData(data)
            }
            if (type.toUpperCase() === CONTENT_TYOE_JSON) {
                fetchdata.body = JSON.stringify(data);
                fetchdata.headers = {
                    "Content-Type": "application/json"
                };
                if (!_.isEmpty(userInfo) && userInfo.ticket) {
                    api += "?token=" + userInfo.ticket
                }

            } else {
                if (process.env.VUE_APP_ENV === "local") {
                    // xdebug 测试参数
                    api += "?XDEBUG_SESSION_START=" + xdebug
                }
            }
            res = fetch(api, fetchdata).catch(err => {
                const errorMsg = '前方拥挤，请稍后重试'
                const error = new Error(errorMsg)
                error.code = 503
                error.message = errorMsg
                throw error
            })
        }
        let timeoutPromise = timeout => {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(new Response("timeout", {
                        status: 504
                    }))
                }, timeout)
            })
        }
        await Promise.race([timeoutPromise(TIMEOUT_TIME), res])
        response = await res
        // if (!isTestApi && status !== 200 && !isTicket) {
        //   // 超时调用备用接口
        //   if (process.env.VUE_APP_ENV !== "local" && process.env.VUE_APP_ENV !== "development") {
        //     const [val1, val2] = api.split("/api")
        //     const [protocol] = val1.split("://")
        //     const newApi = `${protocol}://${STANDBY_API}/api${val2}`
        //     if (isGet) {
        //       const fetchURL = params ? `${newApi}?${params}` : newApi
        //       response = await fetch(fetchURL, {
        //         credentials: "include"
        //       })
        //     } else {
        //       let fetchdata = {
        //         method,
        //         credentials: "include",
        //         body: objectToFormData(data)
        //       }
        //       if (type.toUpperCase() === CONTENT_TYOE_JSON) {
        //         fetchdata.body = JSON.stringify(data);
        //         fetchdata.headers = {
        //           "Content-Type": "application/json"
        //         };
        //       }
        //       response = await fetch(newApi, fetchdata)
        //     }
        //   } else {
        //     response = await res
        //   }
        // } else {
        //   response = await res
        //   if (isTestApi) {
        //     localStorage.removeItem('hasTimeOut')
        //   }
        // }

        checkStatus(response)
        const text = await response.text()

        if (text) {
            let json = text
            if (typeof text === "string") {
                json = JSON.parse(text)
            }
            if (json.code === 0) {
                return json.data
            }
            const errorMsg = json.msg
            const error = new Error(errorMsg)
            error.code = json.code
            error.message = errorMsg
            if (errorMsg.indexOf('用户异常') !== -1) {
                h5Logout()
                setTimeout(() => {
                    judgeLogin()
                }, 300);
            }
            throw error
        }
    }

    loadByImg = (api, conditions) => {
        const imgELE = new Image()
        const params = qs.stringify(conditions)
        const fetchURL = params ? `${api}?${params}` : api
        imgELE.src = fetchURL
    }
}

export default new ApiInvoker()